export default "__VITE_PUBLIC_ASSET__93a3c3c3__"